import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {isNullOrUndefined} from '@uirouter/core';
import {isArray} from 'util';
import { isObject } from '@angular-package/type';
const ROUTE_DATA_BREADCRUMB = 'breadcrumb';
const ROUTE_KEY_BREADCRUMB = 'breadcrumbKey';


function extractLabelFromArray(child: ActivatedRoute, breadcrumb) {
  let o = null;
  if (child.snapshot.data[breadcrumb.resolveKey] && isArray(breadcrumb.fieldKey)) {
    o = child.snapshot.data[breadcrumb.resolveKey];
    breadcrumb.fieldKey.forEach(_key => o = isObject(o) ? o[_key] : null);
  }
  return o;
}

function resolveBredcrumbKey(child: ActivatedRoute, breadcrumb) {
  if (!breadcrumb.resolveKey) {
    return null;
  }
  const result = extractLabelFromArray(child, breadcrumb);
  if (result) {
    return result;
  }
  const data = child.snapshot.data[breadcrumb.resolveKey];
  if (isArray (data)) {
    const paramValue = Object.values(child.snapshot.params);
    return data.filter(_s => (_s as any).id + '' === paramValue[0])[0][breadcrumb.fieldKey];
  }
  return child.snapshot.data[breadcrumb.resolveKey] ? child.snapshot.data[breadcrumb.resolveKey][breadcrumb.fieldKey] || breadcrumb.fieldKey : breadcrumb.fieldKey;
}

function resolveBredcrumbLabel(child: ActivatedRoute, breadcrumb) {
  if (!breadcrumb.label) {
    return null;
  }
  return breadcrumb.label;
}


function replaceParamsFromUrl(child: ActivatedRoute, url) {
  let resultUrl = '' + url;
  Object.keys(child.snapshot.params).forEach(_key => resultUrl = resultUrl.replace(':' + _key, child.snapshot.params[_key]));
  return resultUrl;
}

function resolveRelativeToAbsolute(base: string, relative: string): string {
  if (!relative || relative.startsWith('/')) {
    return relative;
  }
  const stack = base.split('/').filter(s => s.length > 0);
  const parts = relative.split('/');
  for (const part of parts) {
    if (part === '..') {
      if (stack.length > 0) { stack.pop(); }
    } else if (part !== '.' && part !== '') {
      stack.push(part);
    }
  }
  return '/' + stack.join('/');
}


function resolveOutlets(child: ActivatedRoute, url) {
  if (!isObject(url) || !(url as any).outlets) {
    return url;
  }
  const outlets = (url as any).outlets;
  Object.keys(outlets).forEach(_outletName => outlets[_outletName] = replaceParamsFromUrl(child, outlets[_outletName]));
  return url;
}

function resolveBreadcrumbUrl(child: ActivatedRoute, breadcrumb) {
  if (!breadcrumb.url) {
    return null;
  }

  if (isArray(breadcrumb.url)) {
    // Копируем, так как иначе конфигурация будет перезаписана в resolveOutlets
    const url = JSON.parse(JSON.stringify(breadcrumb.url));
    return url.map(_url => isObject(_url)
      ? resolveOutlets(child, _url)
      : replaceParamsFromUrl(child, _url));
  }


  return replaceParamsFromUrl(child, breadcrumb.url);
}

function resolveBreadcrumbList(child: ActivatedRoute, routerLink, basePath?: string) {
  const breadcrumbs = child.snapshot.data.breadcrumbs || [];
  breadcrumbs.push(child.snapshot.data[ROUTE_DATA_BREADCRUMB]);
  breadcrumbs.push(child.snapshot.data[ROUTE_KEY_BREADCRUMB]);

  return breadcrumbs
    .filter(_breadcrumb => !isNullOrUndefined(_breadcrumb))
    .map(_breadcrumb => {
      let url = resolveBreadcrumbUrl(child, _breadcrumb) || [routerLink];
      if (typeof url === 'string' && basePath) {
        url = resolveRelativeToAbsolute(basePath, url);
      }
      return {
        label: '' + (resolveBredcrumbKey(child, _breadcrumb) || resolveBredcrumbLabel(child, _breadcrumb) || _breadcrumb),
        url,
        ...(typeof url === 'string' ? {clearOutlets: true} : {})
      };
    });
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  current: MenuItem[] = [];
  constructor(private route: ActivatedRoute) {
  }

  public createItems() {
    return this.createBreadcrumbs(this.route.root);
  }

  private createBreadcrumbs(route: ActivatedRoute, routerLink: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        routerLink += `/${routeURL}`;
      }

      const bl = resolveBreadcrumbList(child, routerLink, routerLink);
      if (bl.length > 0) {
        breadcrumbs = [...breadcrumbs, ...bl];
      }


      this.current = this.createBreadcrumbs(child, routerLink, breadcrumbs);
      return this.current;
    }
  }

}
